import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  productDetails: {},
  productComplete: {},
  errors: {},
  requesting: null,
  requestingComplete: null,
};

const Slice = createSlice({
  name: '@admin/Inventory|Products|Details',
  initialState,
  reducers: {
    
    /**
     * RESET
     */
    initialState: (state) => {
      state.requesting = null;
      state.requestingComplete = null;
      state.errors = {};
      state.productDetails = {};
      state.productComplete = {};
    },

    /**
     * GET PRODUCT DETAILS (Basic)
     */
    getProductDetails: (state) => {
      state.requesting = true;
      state.productDetails = {};
    },
    getProductDetailsSuccess: (state, action) => {
      const { payload } = action;
      state.productDetails = payload;
      state.requesting = false;
    },
    getProductDetailsFailed: (state, action) => {
      state.errors = action.payload;
      state.requesting = false;
    },

    /**
     * GET PRODUCT COMPLETE (Advanced)
     */
    getProductComplete: (state) => {
      state.requestingComplete = true;
      state.productComplete = {};
    },
    getProductCompleteSuccess: (state, action) => {
      const { payload } = action;
      state.productComplete = payload;
      state.requestingComplete = false;
    },
    getProductCompleteFailed: (state, action) => {
      state.errors = action.payload;
      state.requestingComplete = false;
    },
    
  },
});

export const Actions = Slice.actions;

const Reducers = {
  AdminInventoryProductDetailsReducers: Slice.reducer,
}
export default Reducers;
